<template>
  <div class="content">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <md-card>
          <md-card-header class="pa-5 white--text d-flex flex-column align-start justify-start"
            style="background-color: #4CAF50; border-top-left-radius: 16px; border-top-right-radius: 16px;">
            <h4 class="title">🚀 Novidades e Funções</h4>
            <p class="category">Confira as últimas melhorias do aplicativo.</p>
          </md-card-header>
          <md-card-content>
            <p class="md-body-1">
              Em parceria com a Mevo, você já pode emitir diretamente pelo AgendaWeb:
            </p>
            <md-list class="md-dense">
              <md-list-item>
                <div class="md-list-item-content-flex">
                  <md-icon class="text-success">check_circle_outline</md-icon>
                  <span class="md-list-item-text">Receitas médicas</span>
                </div>
              </md-list-item>
              <md-list-item>
                <div class="md-list-item-content-flex">
                  <md-icon class="text-success">check_circle_outline</md-icon>
                  <span class="md-list-item-text">Pedidos de exame</span>
                </div>
              </md-list-item>
              <md-list-item>
                <div class="md-list-item-content-flex">
                  <md-icon class="text-success">check_circle_outline</md-icon>
                  <span class="md-list-item-text">Atestados</span>
                </div>
              </md-list-item>
              <md-list-item>
                <div class="md-list-item-content-flex">
                  <md-icon class="text-success">check_circle_outline</md-icon>
                  <span class="md-list-item-text">Relatórios médicos</span>
                </div>
              </md-list-item>
            </md-list>
            <p class="md-body-1">
              Tudo integrado à sua agenda, de forma prática, rápida e segura.
            </p>
            
            <md-divider></md-divider>

            <div class="md-layout md-gutter md-alignment-center">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <a href="https://tutorial.konsistbeta.com.br" target="_blank" class="md-button md-primary md-raised md-block centered-button-content">
                  <md-icon>ondemand_video</md-icon>
                  Acesse os vídeos de treinamento
                </a>
              </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <router-link
                    :to="{ name: 'PesquisaPaciente' }"
                    class="md-button md-primary md-raised md-block centered-button-content"
                  >
                    <md-icon>rocket_launch</md-icon>
                    Emitir receitas, atestados e mais
                  </router-link>
                </div>
            </div>

          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100">
        <md-card>
          <md-card-header class="pa-5 white--text d-flex flex-column align-start justify-start"
            style="background-color: #20B2AA; border-top-left-radius: 16px; border-top-right-radius: 16px;">
            <h4 class="title">✨ Atualizações Recentes</h4>
            <p class="category">Últimas correções e melhorias.</p>
          </md-card-header>
          <md-card-content>
              <md-list>
                <md-list-item>
                  <div class="md-list-item-content-flex">
                    <md-icon>person_search</md-icon>
                    <span class="md-list-item-text">
                      Busca de Pacientes e Prontuários: Agora é possível pesquisar pacientes para acessar seus prontuários e emitir documentos médicos de forma ágil e centralizada.
                    </span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-content-flex">
                    <md-icon>edit_note</md-icon>
                    <span class="md-list-item-text">
                      Emissão de Documentos: A emissão de atestados, receitas, pedidos de exames e relatórios foi aprimorada e pode ser feita diretamente pela tela da agenda, do prontuário ou da ficha do paciente.
                    </span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-content-flex">
                    <md-icon>palette</md-icon>
                    <span class="md-list-item-text">
                      Design Otimizado: O design foi atualizado com melhorias visuais para uma interface mais leve e intuitiva.
                    </span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-content-flex">
                    <md-icon>bug_report</md-icon>
                    <span class="md-list-item-text">
                      Correção de Bugs: Foram implementadas diversas correções para bugs, garantindo o bom funcionamento do sistema em dispositivos móveis.
                    </span>
                  </div>
                </md-list-item>
              </md-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
/* Estilo para garantir o alinhamento vertical dos itens da lista */
.md-list-item-content-flex {
  display: flex;
  align-items: flex-start; /* Alinha topo do texto com o ícone */
  gap: 8px;
  flex-wrap: nowrap;
}
.md-list-item-text {
  white-space: normal;     /* Permite quebra de linha */
  word-break: break-word;  /* Quebra palavras longas */
  flex: 1;                 /* Ocupa o espaço restante */
  font-size: 14px;         /* Opcional: diminui a fonte em telas pequenas */
}
/* Estilo para centralizar o conteúdo do botão, usando alinhamento vertical */
.centered-button-content {
  display: flex;
  flex-direction: column; /* Organiza o ícone e o texto em coluna */
  align-items: center; /* Centraliza horizontalmente */
  text-align: center; /* Garante que o texto multilinha também seja centralizado */
}
@media (max-width: 600px) {
  .md-list-item-text {
    font-size: 13px;
  }
}
</style>